import React from "react";

// Material UI
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import DialogActions from '@mui/material/DialogActions'
import Typography from "@mui/material/Typography";
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Chip from '@mui/material/Chip';

// Component
import Modal from '../modal/index'

// Style
import useStyles from "./styles";


const SearchProductModal = ({ open, onClose, variant, product }) => {
  const { classes } = useStyles();

  return (
    <Modal
      maxWidth="sm"
      title={`${variant?.name} - ${variant?.color.name}`}
      open={open}
      onClose={onClose}
      contentProps={{ dividers: true }}
      customButtons={() => (
        <DialogActions>
          <Button onClick={onClose} color="primary" variant="text" autoFocus>
            Cerrar
          </Button>
        </DialogActions>
      )}
    >
      <Grid container direction="column" spacing={2}>
        <Grid direction="row">
          <Grid>
              <Breadcrumbs
              aria-label="breadcrumb"
              >
              {product.categories.map((cat) => (
                   <Chip
                    key={cat}
                    className={classes.breadcrumbsStyles}
                    label={cat.description}
                    color="primary"
                   />
            ))}
            </Breadcrumbs>
          </Grid>
        </Grid>
        <Grid size="grow">
          <Typography>Master Id: {product.id} </Typography>
        </Grid>
        <Grid size="grow">
          {variant?.size?.description && (
            <Typography>Talle: {variant.size.description}</Typography>
          )}
        </Grid>
        <Grid size="grow">
          <div dangerouslySetInnerHTML={{ __html: variant?.description }} />
        </Grid>
        <Grid size="grow">
          <Typography>Piezas: {product.pieces || 0} </Typography>
        </Grid>
        {variant?.promotions && variant?.promotions.length > 0 && (
          <Grid container direction="column" spacing={1} size="grow">
            <Grid size="grow">
              <Typography variant="subtitle1">Promociones</Typography>
            </Grid>
            {variant?.promotions.map((pr) => (
              <Grid key={pr.id} size="grow">
                <div className={classes.promotionContainer}>
                  {pr.iconUrl && (
                    <div className={classes.promotionImage}>
                      <img
                        src={pr.iconUrl}
                        alt={pr.promotionTypeName}
                        width="50"
                        height="auto"
                      />
                    </div>
                  )}
                  <Typography variant="inherit">
                    ({pr.promotionTypeName}) {pr.name}
                  </Typography>
                </div>
              </Grid>
            ))}
          </Grid>
        )}
      </Grid>
    </Modal>
  );
};

export default SearchProductModal;
